module.exports = __webpack_public_path__ + "img/xiaodengta.3f7736f9.png";